import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTenantTranslation } from "hooks/formatters";
import { MixDisplayMode, ProcessedBasketComparison } from "../types";
import { HeatBasketSourceCard } from "./HeatBasketSourceCard";
import { MissingMixPlaceholder } from "./MissingMixPlaceholder";

interface HeatBasketRowProps {
  basket: ProcessedBasketComparison;
  availableMixSources: string[];
  displayMode: MixDisplayMode;
}

const cardVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.15 },
  },
};

export const HeatBasketRow: React.FC<HeatBasketRowProps> = ({
  basket,
  availableMixSources,
  displayMode,
}) => {
  const { t } = useTenantTranslation();

  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 2,
        bgcolor: "background.paper",
        border: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "fontWeightSemiBold" }}>
        {t("basket")} {basket.basketNumber}
      </Typography>

      <Stack
        direction="row"
        spacing={1.5}
        sx={{ overflowX: "auto", px: "2px" }}
      >
        {availableMixSources.map((sourceName, index) => {
          const source = basket.sources.find(
            (s) => s.sourceName === sourceName
          );
          return (
            <motion.div key={sourceName} variants={cardVariants}>
              {source ? (
                <HeatBasketSourceCard
                  source={source}
                  isFirst={index === 0}
                  displayMode={displayMode}
                />
              ) : (
                <MissingMixPlaceholder source={sourceName} width={244} />
              )}
            </motion.div>
          );
        })}
      </Stack>
    </Box>
  );
};
